<template>
  <Modal name="CONFIRM_APPOINTMENT_MODAL" :title="$t('appointment.adminActions.confirmAppointmentManually')">
    <template v-slot:body>
      <ConfirmAppointmentDetails />
      <v-divider class="my-8" />
      <ConfirmAppointmentForm @refreshMap="refreshMap" :appointment="appointment" isManual />
    </template>
  </Modal>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

import Modal from '@/components/app/Modal'
import ConfirmAppointmentForm from '@/views/confirmAppointment/ConfirmAppointmentForm';
import ConfirmAppointmentDetails from '@/views/confirmAppointment/ConfirmAppointmentDetails';

export default {
  name: 'ModalConfirmAppointmentManually',

  components: {
    Modal,
    ConfirmAppointmentForm,
    ConfirmAppointmentDetails,
  },

  props: {
    appointment: {
      type: Object,
      required: false,
    }
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['fetchConfirmAppointmentData']),

    refreshMap() {
      this.$emit('refreshMap')
    }
  },

  watch: {
    appointment(value) {
      if (value && value.id) {
        this.fetchConfirmAppointmentData(value.id)
      }
    }
  },
}
</script>
